module.exports = __webpack_public_path__ + "img/notice-i-1.c1c1d442.png";